/*
  - name: page name
  - path: page path
  - icon: page icon
  - notification: display notification icon
  - nav: display NavigationBar & HomeNavigation in this page
  - hide: do not show in HomeNavigation
  - adminOnly: only visible and accessible by admins
  - children: sub-menu items shown in a dropdown (item becomes a dropdown trigger)
*/
export const PAGES = [
  { name: 'HOMENAV.PAGES.HOMEPAGE', path: '/', nav: true, hide: true },
  { name: 'HOMENAV.PAGES.ALLOCATIONS', path: '/allocations', nav: true, hide: false },
  { name: 'HOMENAV.PAGES.SUMMARY', path: '/summary', nav: true, hide: false },
  { name: 'HOMENAV.PAGES.PROFESSIONALS', path: '/professionals', nav: true, hide: false },
  { name: 'HOMENAV.PAGES.CHARGEABILITY', path: '/chargeability', nav: true, hide: false },
  { name: 'HOMENAV.PAGES.REQUESTS', path: '/requests', nav: true, hide: false },
  { name: 'HOMENAV.PAGES.RECRUITMENT', path: '/recruitment', nav: true, hide: false },
  {
    name: 'HOMENAV.PAGES.ADMIN',
    path: '/admin',
    nav: true,
    hide: false,
    adminOnly: true,
    children: [
      { name: 'HOMENAV.PAGES.CLIENTS', path: '/clients' },
      { name: 'HOMENAV.PAGES.ENGAGEMENTS', path: '/engagements' },
      { name: 'HOMENAV.PAGES.HOURS_REPORT', path: '/hours-report' },
      { name: 'HOMENAV.PAGES.FILE_UPLOAD', path: '/file-upload' },
      { name: 'HOMENAV.PAGES.PROFESSIONAL_LOAD', path: '/professional-load' },
      { name: 'HOMENAV.PAGES.USER_MANAGEMENT', path: '/admin' },
    ]
  },
  { name: 'HOMENAV.PAGES.LOGIN', path: '/login', nav: false, hide: true },
];
